import React from "react";
import RightIcon from "./Icons/Right";
import TrueIcon from "./Icons/True";
import { StyledHCard6 } from "./Styles";
import { useTranslation } from "react-i18next";



function ClientHorizontalCard({
  title,
  subtitle,
  visionPoints,
  missionPoints,
  icon,
}) {
  const { t, i18n } = useTranslation();
  return (
    <StyledHCard6.SingleCard>
      <StyledHCard6.BusinessSec>
        <StyledHCard6.Title>
          <h2>{title}</h2>
          <span>{subtitle}</span>
        </StyledHCard6.Title>

        <StyledHCard6.Info>
          <img src={icon} alt="Icon" />
          <StyledHCard6.ItemSec className="vision" lang={i18n.language}>
            <div className="title">{t("yourvision")}</div>
            <ul>
              {visionPoints.map((point, index) => (
                <li key={index}>
                  <TrueIcon color={"#caa037"} width={14} height={14} />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </StyledHCard6.ItemSec>
        </StyledHCard6.Info>
      </StyledHCard6.BusinessSec>

      <StyledHCard6.TechSec>
        <StyledHCard6.ItemSec className="mission">
          <div className="title">{t("ourmission")}</div>
          <ul>
            {missionPoints.map((point, index) => (
              <li key={index}>
                <RightIcon color={"#5c0630"} width={16} height={16} />
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </StyledHCard6.ItemSec>
      </StyledHCard6.TechSec>
    </StyledHCard6.SingleCard>
  );
}

export default ClientHorizontalCard;
